var _GoogleWebController;
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import { runEngine } from "../../../framework/src/RunEngine";

//@ts-ignore
import { gapi } from "gapi-script";
const configJSON = require("./config");
export class GoogleWebDelegate {
  googleUserStatusChanged(userInfo, isRegistration) {}
}
class GoogleWebController {
  constructor() {
    this.loadAuth2();
    this.googleLogIn = this.googleLogIn.bind(this);
    this.updateGoogleUser = this.updateGoogleUser.bind(this);
  }

  ///////////////////////////////////
  // GooGle DESKTOP Methods
  loadAuth2() {
    //@ts-ignore
    window.gapi.load("auth2", () => {
      //@ts-ignore
      window.gapi.auth2.init({
        client_id: configJSON.clientID
      });
    });
  }
  signinChanged(val) {
    runEngine.debugLog("Signin state changed to ", val);
  }
  userChanged(user, isRegistration) {
    runEngine.debugLog("USER NOW: ", user);
    if (GoogleWebController.instance.updateGoogleUser(user)) {
      GoogleWebController.instance.delegateClass.googleUserStatusChanged(GoogleWebController.instance.googleUserInfo, isRegistration);
    }
  }
  googleLogIn(delegateClass) {
    try {
      const auth2 = gapi.auth2.getAuthInstance();
      GoogleWebController.instance.googleUser = null;
      GoogleWebController.instance.delegateClass = delegateClass;
      // Listen for sign-in state changes.
      auth2.isSignedIn.listen(GoogleWebController.instance.signinChanged);
      //@ts-ignore
      auth2.currentUser.listen(GoogleWebController.instance.userChanged);
      return auth2.signIn();
    } catch (error) {
      runEngine.debugLog(error);
    }
  }
  updateGoogleUser(googleUser) {
    if (googleUser && googleUser !== GoogleWebController.instance.googleUser) {
      GoogleWebController.instance.googleUser = googleUser;
      var auth2 = gapi.auth2.getAuthInstance();
      var profile = auth2.currentUser.get().getBasicProfile();
      if (profile) {
        var userEmail = profile.getEmail();
        var userId = profile.getId();
        runEngine.debugLog(userEmail + "_______" + userId);
        GoogleWebController.instance.googleUserInfo = {
          email: userEmail,
          id: userId
        };
        return true;
      }
    }
    return false;
  }
}
_GoogleWebController = GoogleWebController;
_defineProperty(GoogleWebController, "instance", new _GoogleWebController());
const googleController = new GoogleWebController();
export default googleController;